import styled from 'styled-components/macro';
import { AspectRatio } from '@yme/utils/constants';
export const EmbedContainer = styled.div `
  iframe {
    height: auto !important;
    aspect-ratio: ${AspectRatio.RectangleLevel3};
  }
`;
